import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Home.css';

/* ─────────────────────────────────────────────────────────────────────────────
   NAV — the public marketing nav, used on the homepage and (via SiteNav, in
   Layout) on every other public page. On the homepage the section links
   smooth-scroll; elsewhere they link to /#section, which Home scrolls to on load.
───────────────────────────────────────────────────────────────────────────── */
const links = [
  { label: 'How it works', id: 'how-it-works' },
  { label: 'Demo',         to: '/demo'        },
  { label: 'Features',     id: 'features'     },
  { label: 'For schools',  to: '/schools'     },
  { label: 'Pricing',      id: 'pricing'      },
];

const HomeNav = ({ activeSection }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { pathname } = useLocation();
  const onHome = pathname === '/';
  const { currentUser } = useAuth();

  const handleClick = (l, e) => {
    setMobileOpen(false);
    if (!onHome || !l.id) return;
    e.preventDefault();
    const el = document.getElementById(l.id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const isActive = l => (l.to ? pathname === l.to || pathname.startsWith(`${l.to}/`) : onHome && activeSection === l.id);
  const target = l => l.to || `/#${l.id}`;

  return (
    <nav className="hp-nav">
      <div className="hp-nav-inner">
        <Link to="/" className="hp-logo">
          <img src="/logo-icon.png" alt="" className="hp-logo-icon" />
          <span>Teach<span className="hp-logo-esl">ESL</span>Pro</span>
        </Link>

        <div className="hp-nav-links">
          {links.map(l => (
            <Link
              key={l.label}
              to={target(l)}
              onClick={e => handleClick(l, e)}
              className={`hp-nav-link${isActive(l) ? ' active' : ''}`}
            >
              {l.label}
            </Link>
          ))}
        </div>

        <div className="hp-nav-actions">
          {currentUser ? (
            <Link to="/home" className="hp-btn hp-btn-primary">Go to dashboard</Link>
          ) : (
            <>
              {/* Outlined pair, set apart from the section links */}
              <div className="hp-nav-pair">
                <Link to="/book-a-demo" className="hp-btn hp-btn-ghost hp-nav-outline hp-nav-demo">Book a demo</Link>
                <Link to="/login"  className="hp-btn hp-btn-ghost hp-nav-outline">Log in</Link>
              </div>
              <Link to="/signup" className="hp-btn hp-btn-primary">Start free trial</Link>
            </>
          )}
        </div>

        <button
          className="hp-hamburger"
          onClick={() => setMobileOpen(o => !o)}
          aria-label="Open menu"
        >
          {mobileOpen ? '✕' : '☰'}
        </button>
      </div>

      <div className={`hp-mobile-menu${mobileOpen ? ' open' : ''}`}>
        {links.map(l => (
          <Link
            key={l.label}
            to={target(l)}
            onClick={e => handleClick(l, e)}
            className="hp-mobile-link"
          >
            {l.label}
          </Link>
        ))}
        {currentUser ? (
          <Link to="/home" className="hp-mobile-link cta" onClick={() => setMobileOpen(false)}>Go to dashboard</Link>
        ) : (
          <>
            <Link to="/book-a-demo" className="hp-mobile-link" onClick={() => setMobileOpen(false)}>Book a demo</Link>
            <Link to="/login"  className="hp-mobile-link" onClick={() => setMobileOpen(false)}>Log in</Link>
            <Link to="/signup" className="hp-mobile-link cta" onClick={() => setMobileOpen(false)}>Start free trial</Link>
          </>
        )}
      </div>
    </nav>
  );
};

/* The nav is position:fixed; this wrapper scopes its styles and reserves its height. */
export const SiteNav = () => (
  <div className="hp-page hp-home site-nav">
    <HomeNav />
  </div>
);

export default HomeNav;
